this.enemy = [
  {
    name: "オリジムシ",
    class: "近距離",
    atktype: "物理",
    hp: 550,
    atk: 130,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "オリジムシ・α",
    class: "近距離",
    atktype: "物理",
    hp: 1050,
    atk: 185,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "オリジムシ・β",
    class: "近距離",
    atktype: "物理",
    hp: 1550,
    atk: 240,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "アシッドムシ",
    class: "遠距離",
    atktype: "物理",
    hp: 2080,
    atk: 180,
    def: 80,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },

  {
    name: "アシッドムシ・α",
    class: "遠距離",
    atktype: "物理",
    hp: 2780,
    atk: 290,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "バクダンムシ",
    class: "近距離",
    atktype: "物理",
    hp: 2460,
    atk: 260,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "バクダンムシ・α",
    class: "近距離",
    atktype: "物理",
    hp: 3700,
    atk: 350,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 820,
    atk: 190,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },

  {
    name: "上級猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 1700,
    atk: 260,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "凶暴猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 370,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "兵士",
    class: "近距離",
    atktype: "物理",
    hp: 1650,
    atk: 200,
    def: 100,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "射撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 1400,
    atk: 240,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "射撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 1900,
    atk: 310,
    def: 150,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "術師",
    class: "遠距離",
    atktype: "術",
    hp: 1600,
    atk: 200,
    def: 50,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 2400,
    atk: 300,
    def: 80,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "上級術師",
    class: "遠距離",
    atktype: "術",
    hp: 7000,
    atk: 240,
    def: 120,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "上級術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 13500,
    atk: 380,
    def: 160,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "空挺兵",
    class: "近距離",
    atktype: "物理",
    hp: 1450,
    atk: 220,
    def: 100,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "空挺隊長",
    class: "近距離",
    atktype: "物理",
    hp: 2300,
    atk: 300,
    def: 100,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "砲兵",
    class: "遠距離",
    atktype: "物理",
    hp: 3300,
    atk: 400,
    def: 150,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "砲兵隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 550,
    def: 150,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "双剣士",
    class: "近距離",
    atktype: "物理",
    hp: 2000,
    atk: 350,
    def: 100,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "双剣隊長",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 450,
    def: 120,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "軽装兵",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 250,
    def: 400,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "軽装隊長",
    class: "近距離",
    atktype: "物理",
    hp: 3700,
    atk: 300,
    def: 500,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "重装兵",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 600,
    def: 800,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "重装隊長",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 600,
    def: 1000,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "重装連隊長",
    class: "近距離",
    atktype: "物理",
    hp: 40000,
    atk: 1000,
    def: 1200,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "BigBob",
    class: "近距離",
    atktype: "物理",
    hp: 22000,
    atk: 1900,
    def: 800,
    res: 30,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "BigAdam",
    class: "近距離",
    atktype: "物理",
    hp: 30000,
    atk: 2700,
    def: 1000,
    res: 30,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "ハガネガニ",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 300,
    def: 500,
    res: 85,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "潜入者",
    class: "近距離",
    atktype: "物理",
    hp: 2200,
    atk: 300,
    def: 90,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ゴースト兵",
    class: "近距離",
    atktype: "しない",
    hp: 2300,
    atk: 100,
    def: 120,
    res: 35,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "怪鳥",
    class: "近距離",
    atktype: "しない",
    hp: 800,
    atk: 0,
    def: 50,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "怪鳥Mk2",
    class: "遠距離",
    atktype: "物理",
    hp: 1550,
    atk: 220,
    def: 50,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "飛龍",
    class: "遠距離",
    atktype: "物理",
    hp: 30000,
    atk: 660,
    def: 170,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "Mvc4",
    class: "近距離",
    atktype: "しない",
    hp: 4000,
    atk: 0,
    def: 150,
    res: 20,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "迷彩射撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 1800,
    atk: 260,
    def: 100,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "迷彩射撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 2700,
    atk: 310,
    def: 130,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "迷彩術師",
    class: "遠距離",
    atktype: "術",
    hp: 2200,
    atk: 350,
    def: 80,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "迷彩術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 4200,
    atk: 400,
    def: 130,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "技術偵察兵",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 270,
    def: 100,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ大剣士",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 600,
    def: 230,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ大剣隊長",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 750,
    def: 250,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ狙撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 450,
    def: 200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ狙撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 570,
    def: 200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ術師",
    class: "遠距離",
    atktype: "術",
    hp: 12000,
    atk: 500,
    def: 200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 18000,
    atk: 700,
    def: 200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズケントゥリオ",
    class: "遠距離",
    atktype: "術",
    hp: 15000,
    atk: 700,
    def: 250,
    res: 35,
    move: 0.78,
    elite: true,
    boss: true,
  },
  {
    name: "リベンジャー",
    class: "近距離",
    atktype: "物理",
    hp: 5000,
    atk: 300,
    def: 200,
    res: 50,
    move: 0.65,
    elite: true,
    boss: false,
  },
  {
    name: "ヴェンデッタ",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 480,
    def: 230,
    res: 50,
    move: 0.65,
    elite: true,
    boss: false,
  },
  {
    name: "ゴースト隊長",
    class: "近距離",
    atktype: "しない",
    hp: 3800,
    atk: 100,
    def: 350,
    res: 35,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "暴徒",
    class: "近距離",
    atktype: "物理",
    hp: 1700,
    atk: 250,
    def: 50,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪暴徒",
    class: "近距離",
    atktype: "物理",
    hp: 2650,
    atk: 350,
    def: 85,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "火炎瓶暴徒",
    class: "遠距離",
    atktype: "物理",
    hp: 1550,
    atk: 180,
    def: 50,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪火炎瓶暴徒",
    class: "遠距離",
    atktype: "物理",
    hp: 2000,
    atk: 250,
    def: 85,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "機動盾兵",
    class: "近距離",
    atktype: "物理",
    hp: 2050,
    atk: 240,
    def: 250,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "機動盾隊長",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 280,
    def: 300,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "流れ者",
    class: "近距離",
    atktype: "物理",
    hp: 5000,
    atk: 500,
    def: 50,
    res: 20,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪流れ者",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 600,
    def: 70,
    res: 20,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "術剣士",
    class: "近距離",
    atktype: "術",
    hp: 4000,
    atk: 350,
    def: 200,
    res: 50,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "術剣隊長",
    class: "近距離",
    atktype: "術",
    hp: 6500,
    atk: 500,
    def: 250,
    res: 50,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "拳刃兵",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 450,
    def: 300,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "拳刃隊長",
    class: "近距離",
    atktype: "物理",
    hp: 6500,
    atk: 550,
    def: 350,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "伐採者",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 750,
    def: 80,
    res: 30,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪伐採者",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 850,
    def: 100,
    res: 30,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "ブッチャー",
    class: "近距離",
    atktype: "物理",
    hp: 9000,
    atk: 850,
    def: 230,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪ブッチャー",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 950,
    def: 270,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "武装戦闘員",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 1050,
    def: 700,
    res: 30,
    move: 0.65,
    elite: true,
    boss: false,
  },
  {
    name: "上級武装戦闘員",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 1500,
    def: 800,
    res: 30,
    move: 0.65,
    elite: true,
    boss: false,
  },
  {
    name: "上級バリア術師",
    class: "遠距離",
    atktype: "術",
    hp: 8500,
    atk: 380,
    def: 400,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "特戦兵士",
    class: "近距離",
    atktype: "物理",
    hp: 3200,
    atk: 350,
    def: 50,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "特戦術師",
    class: "遠距離",
    atktype: "術",
    hp: 4000,
    atk: 400,
    def: 250,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "特戦術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 450,
    def: 300,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "切り込み兵",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 410,
    def: 50,
    res: 25,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "切り込み隊長",
    class: "近距離",
    atktype: "物理",
    hp: 5000,
    atk: 500,
    def: 80,
    res: 25,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "バクダンバチ",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 800,
    def: 150,
    res: 30,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "バクダンバチG",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 1500,
    def: 220,
    res: 30,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "アーツバードA1",
    class: "遠距離",
    atktype: "術",
    hp: 2700,
    atk: 220,
    def: 100,
    res: 65,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "アーツバードA2",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 600,
    def: 140,
    res: 65,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "コキュートス",
    class: "近距離",
    atktype: "しない",
    hp: 6500,
    atk: 100,
    def: 600,
    res: 30,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "寄生兵",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 250,
    def: 100,
    res: 30,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "寄生隊長",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 300,
    def: 150,
    res: 30,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "寄生流れ者",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 500,
    def: 130,
    res: 30,
    move: 0.65,
    elite: false,
    boss: false,
  },
  {
    name: "寄生凶悪流れ者",
    class: "近距離",
    atktype: "物理",
    hp: 11000,
    atk: 650,
    def: 200,
    res: 30,
    move: 0.65,
    elite: false,
    boss: false,
  },
  {
    name: "クラッシャー",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 1000,
    def: 1000,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪クラッシャー",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 1500,
    def: 2000,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "歩兵",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 280,
    def: 85,
    res: 40,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "歩兵隊長",
    class: "近距離",
    atktype: "物理",
    hp: 3700,
    atk: 330,
    def: 100,
    res: 40,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "狙撃歩兵",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 150,
    def: 100,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "狙撃歩兵隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 200,
    def: 200,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ロックブレイカー",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 750,
    def: 100,
    res: 40,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪ロックブレイカー",
    class: "近距離",
    atktype: "物理",
    hp: 13000,
    atk: 900,
    def: 100,
    res: 40,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "工作員",
    class: "近距離",
    atktype: "術",
    hp: 6000,
    atk: 300,
    def: 150,
    res: 50,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "工作員隊長",
    class: "近距離",
    atktype: "術",
    hp: 9000,
    atk: 350,
    def: 230,
    res: 50,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "制式術師",
    class: "遠距離",
    atktype: "術",
    hp: 3000,
    atk: 320,
    def: 100,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "制式術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 4000,
    atk: 350,
    def: 200,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "機動軽装兵",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 200,
    def: 400,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "機動軽装兵隊長",
    class: "近距離",
    atktype: "物理",
    hp: 3700,
    atk: 300,
    def: 500,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "シロアリ",
    class: "近距離",
    atktype: "しない",
    hp: 2300,
    atk: 100,
    def: 120,
    res: 40,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "シロアリ隊長",
    class: "近距離",
    atktype: "しない",
    hp: 3800,
    atk: 100,
    def: 260,
    res: 45,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "重装兵N型",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 700,
    def: 800,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "重装兵S型",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 700,
    def: 1000,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "シシリアン",
    class: "近距離",
    atktype: "物理",
    hp: 2700,
    atk: 250,
    def: 100,
    res: 10,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪シシリアン",
    class: "近距離",
    atktype: "物理",
    hp: 3800,
    atk: 350,
    def: 160,
    res: 10,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "拳闘士崩れ",
    class: "近距離",
    atktype: "物理",
    hp: 3200,
    atk: 290,
    def: 250,
    res: 0,
    move: 0.95,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪拳闘士",
    class: "近距離",
    atktype: "物理",
    hp: 4200,
    atk: 380,
    def: 300,
    res: 0,
    move: 0.95,
    elite: false,
    boss: false,
  },
  {
    name: "射手",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 180,
    def: 150,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪射手",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 230,
    def: 200,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ロードローラー",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 800,
    def: 800,
    res: 20,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪ロードローラー",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 1000,
    def: 1000,
    res: 30,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "凶漢",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 700,
    def: 500,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "鬼凶漢",
    class: "遠距離",
    atktype: "物理",
    hp: 13000,
    atk: 800,
    def: 600,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "灰尾",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 700,
    def: 250,
    res: 20,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "灰尾香主",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 800,
    def: 250,
    res: 20,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "寄生重装兵",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 600,
    def: 800,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "寄生重装隊長",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 800,
    def: 1000,
    res: 0,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "狂化寄生兵",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 1000,
    def: 200,
    res: 30,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "狂化寄生隊長",
    class: "近距離",
    atktype: "物理",
    hp: 30000,
    atk: 1750,
    def: 230,
    res: 30,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "狂化寄生投擲兵",
    class: "遠距離",
    atktype: "物理",
    hp: 15000,
    atk: 750,
    def: 200,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "狂化寄生投骨兵",
    class: "遠距離",
    atktype: "物理",
    hp: 22000,
    atk: 1050,
    def: 220,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "スノーデビル",
    class: "近距離",
    atktype: "物理",
    hp: 3400,
    atk: 360,
    def: 100,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "スノーファング",
    class: "近距離",
    atktype: "物理",
    hp: 3150,
    atk: 350,
    def: 0,
    res: 30,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "フロストファング",
    class: "近距離",
    atktype: "物理",
    hp: 4650,
    atk: 430,
    def: 0,
    res: 30,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "スノースナイパー",
    class: "遠距離",
    atktype: "物理",
    hp: 2500,
    atk: 290,
    def: 80,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "スノースナイパー隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 3500,
    atk: 360,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ヒョウバクムシ",
    class: "近距離",
    atktype: "物理",
    hp: 3250,
    atk: 300,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ヒョウバクムシα",
    class: "近距離",
    atktype: "物理",
    hp: 4850,
    atk: 370,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "スノーキャスター",
    class: "遠距離",
    atktype: "術",
    hp: 5000,
    atk: 320,
    def: 200,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "スノーキャスター隊長",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 400,
    def: 250,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "アイスピッカー",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 830,
    def: 500,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "アイスブレイカー",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 1100,
    def: 600,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ヒョウバクバチ",
    class: "遠距離",
    atktype: "術",
    hp: 4000,
    atk: 500,
    def: 180,
    res: 30,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ刀術師",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 300,
    def: 70,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ刀術隊長",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 370,
    def: 100,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ突撃兵",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 450,
    def: 150,
    res: 40,
    move: 0.25,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ突撃隊長",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 500,
    def: 230,
    res: 40,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ歩哨",
    class: "近距離",
    atktype: "しない",
    hp: 4000,
    atk: 0,
    def: 100,
    res: 30,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ歩哨隊長",
    class: "近距離",
    atktype: "しない",
    hp: 5000,
    atk: 0,
    def: 160,
    res: 30,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ呪術師",
    class: "遠距離",
    atktype: "術",
    hp: 15000,
    atk: 700,
    def: 250,
    res: 50,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ呪術隊長",
    class: "遠距離",
    atktype: "術",
    hp: 22000,
    atk: 850,
    def: 300,
    res: 50,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ魔剣士",
    class: "近距離",
    atktype: "術",
    hp: 6500,
    atk: 400,
    def: 200,
    res: 50,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ魔剣隊長",
    class: "近距離",
    atktype: "術",
    hp: 9500,
    atk: 500,
    def: 250,
    res: 50,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "ボンバークラッシャー",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 1700,
    def: 800,
    res: 0,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪ボンバークラッシャー",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 2200,
    def: 1000,
    res: 0,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 2900,
    atk: 350,
    def: 150,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊上級猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 3800,
    atk: 420,
    def: 150,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊戦士",
    class: "近距離",
    atktype: "物理",
    hp: 3300,
    atk: 300,
    def: 300,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊戦士隊長",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 330,
    def: 350,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊狙撃手",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 340,
    def: 300,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊狙撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 390,
    def: 300,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊伝令兵",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 300,
    def: 120,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊伝令隊長",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 360,
    def: 120,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "遊撃隊盾兵",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 700,
    def: 1300,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊盾兵隊長",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 800,
    def: 1500,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊砲兵",
    class: "遠距離",
    atktype: "物理",
    hp: 5500,
    atk: 450,
    def: 550,
    res: 20,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊砲兵隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 6500,
    atk: 590,
    def: 550,
    res: 20,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊強襲兵",
    class: "近距離",
    atktype: "物理",
    hp: 3800,
    atk: 360,
    def: 550,
    res: 20,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊強襲隊長",
    class: "近距離",
    atktype: "物理",
    hp: 5000,
    atk: 430,
    def: 550,
    res: 20,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊サルカズ戦士",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 480,
    def: 400,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊サルカズ戦士隊長",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 580,
    def: 400,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ傭兵",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 480,
    def: 400,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊サルカズ術師",
    class: "遠距離",
    atktype: "術",
    hp: 7000,
    atk: 350,
    def: 400,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "遊撃隊サルカズ術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 10000,
    atk: 450,
    def: 400,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ傭兵術師",
    class: "遠距離",
    atktype: "術",
    hp: 7000,
    atk: 350,
    def: 400,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "リターニア反乱兵",
    class: "近距離",
    atktype: "術",
    hp: 3000,
    atk: 130,
    def: 130,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "リターニア反乱兵隊長",
    class: "近距離",
    atktype: "術",
    hp: 4000,
    atk: 180,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "冬霊猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 300,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "冬霊上級猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 360,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "リターニア術師",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 300,
    def: 200,
    res: 50,
    move: 0.85,
    elite: false,
    boss: false,
  },
  {
    name: "リターニア上級術師",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 360,
    def: 200,
    res: 50,
    move: 0.85,
    elite: false,
    boss: false,
  },
  {
    name: "冬霊シャーマン",
    class: "近距離",
    atktype: "術",
    hp: 20000,
    atk: 500,
    def: 300,
    res: 50,
    move: 1.5,
    elite: true,
    boss: false,
  },
  {
    name: "上級冬霊シャーマン",
    class: "近距離",
    atktype: "術",
    hp: 30000,
    atk: 650,
    def: 300,
    res: 50,
    move: 1.5,
    elite: true,
    boss: false,
  },
  {
    name: "マドロック隊投魔兵",
    class: "遠距離",
    atktype: "物理",
    hp: 7000,
    atk: 400,
    def: 400,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "マドロック隊投魔隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 500,
    def: 500,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "マドロック隊実動部隊員",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 900,
    def: 800,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "マドロック隊実動部隊長",
    class: "近距離",
    atktype: "物理",
    hp: 13000,
    atk: 1000,
    def: 800,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "マドロックの巨像",
    class: "近距離",
    atktype: "物理",
    hp: 100000,
    atk: 3000,
    def: 700,
    res: 30,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "巫術の巨像",
    class: "近距離",
    atktype: "物理",
    hp: 150000,
    atk: 3600,
    def: 800,
    res: 40,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "ティアカウ戦士",
    class: "近距離",
    atktype: "物理",
    hp: 2600,
    atk: 290,
    def: 60,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ護衛",
    class: "近距離",
    atktype: "物理",
    hp: 3600,
    atk: 380,
    def: 110,
    res: 10,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ投槍兵",
    class: "遠距離",
    atktype: "物理",
    hp: 2800,
    atk: 240,
    def: 100,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ投槍名人",
    class: "遠距離",
    atktype: "物理",
    hp: 3800,
    atk: 340,
    def: 150,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ猛攻兵",
    class: "近距離",
    atktype: "物理",
    hp: 5500,
    atk: 320,
    def: 380,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ猛攻隊長",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 350,
    def: 460,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ呪術師",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 250,
    def: 200,
    res: 70,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ大呪術師",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 350,
    def: 250,
    res: 80,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ティアカウ破壊者",
    class: "遠距離",
    atktype: "物理",
    hp: 7500,
    atk: 650,
    def: 550,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ティアカウ破壊王",
    class: "遠距離",
    atktype: "物理",
    hp: 9500,
    atk: 750,
    def: 700,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ティアカウ勇士",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 700,
    def: 950,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ティアカウチャンピオン",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 1000,
    def: 1100,
    res: 10,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "無名の独立騎士",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 280,
    def: 150,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "無名の精鋭騎士",
    class: "近距離",
    atktype: "物理",
    hp: 3800,
    atk: 360,
    def: 150,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "訓練用鉗獣",
    class: "近距離",
    atktype: "物理",
    hp: 2000,
    atk: 380,
    def: 450,
    res: 30,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "訓練用狂暴鉗獣",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 450,
    def: 700,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ロアー見習い騎士",
    class: "遠距離",
    atktype: "物理",
    hp: 2800,
    atk: 300,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ロアー精鋭騎士",
    class: "遠距離",
    atktype: "物理",
    hp: 3800,
    atk: 420,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "「合成樹脂」シェブチック",
    class: "遠距離",
    atktype: "物理",
    hp: 3800,
    atk: 600,
    def: 100,
    res: 0,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "盾持ち独立騎士",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 700,
    def: 1000,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "盾持ち精鋭騎士",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 700,
    def: 1300,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ブラッドボイル見習い騎士",
    class: "近距離",
    atktype: "物理",
    hp: 9000,
    atk: 500,
    def: 800,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ブラッドボイル精鋭騎士",
    class: "近距離",
    atktype: "物理",
    hp: 13000,
    atk: 650,
    def: 800,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「錆銅」オルマー・イングラ",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 700,
    def: 800,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ブレードヘルム見習い騎士",
    class: "遠距離",
    atktype: "術",
    hp: 10000,
    atk: 550,
    def: 700,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "ブレードヘルム精鋭騎士",
    class: "遠距離",
    atktype: "術",
    hp: 13000,
    atk: 650,
    def: 700,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "「左腕」タイタス・トポラ",
    class: "遠距離",
    atktype: "術",
    hp: 20000,
    atk: 750,
    def: 700,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "協賛ドローン",
    class: "近距離",
    atktype: "しない",
    hp: 5000,
    atk: 0,
    def: 150,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "豪華協賛ドローン",
    class: "近距離",
    atktype: "しない",
    hp: 10000,
    atk: 0,
    def: 300,
    res: 40,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "闘志高揚ドローン",
    class: "近距離",
    atktype: "しない",
    hp: 5000,
    atk: 0,
    def: 150,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "感染者監視官",
    class: "近距離",
    atktype: "物理",
    hp: 3300,
    atk: 330,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "感染者上級監視官",
    class: "近距離",
    atktype: "物理",
    hp: 4300,
    atk: 400,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス裂獣",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 380,
    def: 100,
    res: 20,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス女王裂獣",
    class: "近距離",
    atktype: "物理",
    hp: 4600,
    atk: 450,
    def: 100,
    res: 20,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス強襲射撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 350,
    def: 200,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス上級強襲射撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 5500,
    atk: 430,
    def: 200,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス重装術師",
    class: "遠距離",
    atktype: "術",
    hp: 5000,
    atk: 340,
    def: 500,
    res: 50,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサス上級重装術師",
    class: "遠距離",
    atktype: "術",
    hp: 6500,
    atk: 420,
    def: 500,
    res: 50,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ウルサスコマンドー",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 550,
    def: 500,
    res: 50,
    move: 1.5,
    elite: true,
    boss: false,
  },
  {
    name: "ウルサスコマンドス隊長",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 700,
    def: 500,
    res: 50,
    move: 1.5,
    elite: true,
    boss: false,
  },
  {
    name: "帝国砲撃誘導機",
    class: "遠距離",
    atktype: "物理",
    hp: 13000,
    atk: 1000,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "帝国砲撃指揮機",
    class: "遠距離",
    atktype: "物理",
    hp: 16000,
    atk: 1200,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "帝国精鋭先鋒",
    class: "近・遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 900,
    def: 800,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "帝国歴戦先鋒",
    class: "近・遠距離",
    atktype: "物理",
    hp: 15000,
    atk: 1200,
    def: 800,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ寄生ケントゥリオ",
    class: "遠距離",
    atktype: "術",
    hp: 10000,
    atk: 600,
    def: 200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ寄生守備ケントゥリオ",
    class: "遠距離",
    atktype: "術",
    hp: 14000,
    atk: 700,
    def: 220,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "「皇帝の利刃」",
    class: "近距離",
    atktype: "物理",
    hp: 50000,
    atk: 0,
    def: 3000,
    res: 90,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "ウルサス民間人",
    class: "近距離",
    atktype: "しない",
    hp: 3500,
    atk: 0,
    def: 50,
    res: 0,
    move: 0.65,
    elite: false,
    boss: false,
  },
  {
    name: "闘士タルラ",
    class: "遠距離",
    atktype: "術",
    hp: 15000,
    atk: 600,
    def: 350,
    res: 50,
    move: 0.45,
    elite: true,
    boss: true,
  },
  {
    name: "一般囚人",
    class: "近距離",
    atktype: "物理",
    hp: 5500,
    atk: 280,
    def: 60,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "重罪囚人",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 380,
    def: 60,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "射手囚人",
    class: "遠距離",
    atktype: "物理",
    hp: 5500,
    atk: 220,
    def: 80,
    res: 30,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "重罪射手囚人",
    class: "遠距離",
    atktype: "物理",
    hp: 7000,
    atk: 320,
    def: 80,
    res: 30,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "拳闘士囚人",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 300,
    def: 300,
    res: 0,
    move: 1.6,
    elite: true,
    boss: false,
  },
  {
    name: "重罪拳闘士囚人",
    class: "近距離",
    atktype: "物理",
    hp: 9500,
    atk: 400,
    def: 400,
    res: 0,
    move: 1.6,
    elite: true,
    boss: false,
  },
  {
    name: "巨漢囚人",
    class: "近距離",
    atktype: "物理",
    hp: 11000,
    atk: 600,
    def: 700,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "重罪巨漢囚人",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 700,
    def: 1000,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "術師囚人",
    class: "近距離",
    atktype: "しない",
    hp: 9000,
    atk: 300,
    def: 100,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "重罪術師囚人",
    class: "近距離",
    atktype: "しない",
    hp: 11000,
    atk: 340,
    def: 200,
    res: 50,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "凶悪犯",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 800,
    def: 400,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "伝説の凶悪犯",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 1000,
    def: 500,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "「ヨツアシ」",
    class: "近距離",
    atktype: "物理",
    hp: 3200,
    atk: 330,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "焦燥する「ヨツアシ」",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 380,
    def: 0,
    res: 30,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "「クヒツム」",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 290,
    def: 120,
    res: 10,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "真面目な「クヒツム」",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 370,
    def: 150,
    res: 10,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "「カマクビ」",
    class: "遠距離",
    atktype: "物理",
    hp: 4800,
    atk: 300,
    def: 240,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "迂遠な「カマクビ」",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 400,
    def: 280,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "「ヤマツミ」",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 700,
    def: 1000,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "不動の「ヤマツミ」",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 800,
    def: 1300,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「オニビ」",
    class: "近距離",
    atktype: "術",
    hp: 2460,
    atk: 120,
    def: 0,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "恍惚の「オニビ」",
    class: "近距離",
    atktype: "術",
    hp: 3700,
    atk: 150,
    def: 0,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "「メカクシ」",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 800,
    def: 600,
    res: 20,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "不休の「メカクシ」",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 1000,
    def: 750,
    res: 25,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "「ソネミ」",
    class: "遠距離",
    atktype: "術",
    hp: 10000,
    atk: 500,
    def: 200,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "複雑な「ソネミ」",
    class: "遠距離",
    atktype: "術",
    hp: 15000,
    atk: 700,
    def: 220,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "「シンイ」",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 1100,
    def: 750,
    res: 25,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "奔放な「シンイ」",
    class: "近距離",
    atktype: "物理",
    hp: 16000,
    atk: 1500,
    def: 900,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "変異体傀儡",
    class: "近距離",
    atktype: "物理",
    hp: 1900,
    atk: 210,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "変異サンドビースト",
    class: "近距離",
    atktype: "物理",
    hp: 2700,
    atk: 320,
    def: 100,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "変異サンドビーストα",
    class: "近距離",
    atktype: "物理",
    hp: 3300,
    atk: 380,
    def: 100,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "変異イワグモ",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 360,
    def: 200,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "変異イワグモα",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 410,
    def: 200,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "変異オオイワグモ",
    class: "遠距離",
    atktype: "物理",
    hp: 15000,
    atk: 600,
    def: 300,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "変異オオイワグモα",
    class: "遠距離",
    atktype: "物理",
    hp: 20000,
    atk: 800,
    def: 300,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "オリジニュータント",
    class: "近距離",
    atktype: "術",
    hp: 4000,
    atk: 1000,
    def: 2000,
    res: 80,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "オリジニュータントα",
    class: "近距離",
    atktype: "術",
    hp: 7000,
    atk: 1500,
    def: 2000,
    res: 80,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「レッドラベル」根絶者",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 1500,
    def: 300,
    res: 30,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "「レッドラベル」根絶尖兵",
    class: "遠距離",
    atktype: "物理",
    hp: 7000,
    atk: 2000,
    def: 300,
    res: 30,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "「レッドラベル」浸透者",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 400,
    def: 500,
    res: 30,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "「レッドラベル」浸透尖兵",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 500,
    def: 500,
    res: 30,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "変異腫瘍",
    class: "近距離",
    atktype: "物理",
    hp: 1000,
    atk: 150,
    def: 0,
    res: 0,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "変異悪性腫瘍",
    class: "近距離",
    atktype: "物理",
    hp: 1500,
    atk: 200,
    def: 0,
    res: 0,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "戦術ホログラム",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 250,
    def: 0,
    res: 0,
    move: 1.3,
    elite: false,
    boss: false,
  },
  {
    name: "戦術ホログラムMK2",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 350,
    def: 0,
    res: 0,
    move: 1.3,
    elite: false,
    boss: false,
  },
  {
    name: "戦術猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 2200,
    atk: 310,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "上級戦術猟犬",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 380,
    def: 0,
    res: 30,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "戦術射撃兵",
    class: "遠距離",
    atktype: "物理",
    hp: 3100,
    atk: 320,
    def: 260,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "戦術射撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 4200,
    atk: 390,
    def: 260,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "戦術重装兵",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 700,
    def: 800,
    res: 40,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "戦術重装隊長",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 700,
    def: 1000,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "対装甲歩兵",
    class: "近・遠距離",
    atktype: "物理",
    hp: 3200,
    atk: 500,
    def: 50,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "対装甲歩兵隊長",
    class: "近・遠距離",
    atktype: "物理",
    hp: 4800,
    atk: 750,
    def: 50,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "ウォーゴースト",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 1100,
    def: 500,
    res: 60,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "伝説のウォーゴースト",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 1400,
    def: 500,
    res: 60,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "破片",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 250,
    def: 80,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "破片タイプU",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 350,
    def: 80,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "鉄砧",
    class: "近距離",
    atktype: "しない",
    hp: 5000,
    atk: 0,
    def: 80,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "鉄砧タイプB",
    class: "近距離",
    atktype: "しない",
    hp: 8000,
    atk: 0,
    def: 80,
    res: 50,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "殻海のランナー",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 280,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したランナー",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 340,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "淵海のスライダー",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 280,
    def: 130,
    res: 10,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したスライダー",
    class: "近距離",
    atktype: "物理",
    hp: 3600,
    atk: 360,
    def: 150,
    res: 10,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "脊海のスピッター",
    class: "遠距離",
    atktype: "物理",
    hp: 4400,
    atk: 280,
    def: 160,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したスピッター",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 320,
    def: 200,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "浮海のドリフター",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 220,
    def: 200,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したドリフター",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 250,
    def: 250,
    res: 20,
    move: 0.75,
    elite: false,
    boss: false,
  },
  {
    name: "鉢海のリーパー",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 400,
    def: 800,
    res: 75,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したリーパー",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 500,
    def: 800,
    res: 75,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "嚢海のクローラー",
    class: "近距離",
    atktype: "しない",
    hp: 25000,
    atk: 300,
    def: 0,
    res: 0,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したクローラー",
    class: "近距離",
    atktype: "しない",
    hp: 35000,
    atk: 400,
    def: 0,
    res: 0,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "始海のピアッサー",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 550,
    def: 240,
    res: 20,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したピアッサー",
    class: "遠距離",
    atktype: "物理",
    hp: 12500,
    atk: 700,
    def: 240,
    res: 20,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "ファースト・トーカー",
    class: "遠距離",
    atktype: "物理",
    hp: 21000,
    atk: 600,
    def: 500,
    res: 20,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "自動メンテナンス機",
    class: "近距離",
    atktype: "しない",
    hp: 6000,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.6,
    elite: false,
    boss: false,
  },
  {
    name: "ヒュムノイの英雄",
    class: "近距離",
    atktype: "しない",
    hp: 40000,
    atk: 500,
    def: 500,
    res: 60,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "ヒュムノイの勇士",
    class: "近・遠距離",
    atktype: "物理",
    hp: 40000,
    atk: 1200,
    def: 1000,
    res: 40,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "潜水員",
    class: "遠距離",
    atktype: "物理",
    hp: 3300,
    atk: 240,
    def: 150,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "潜水隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 320,
    def: 200,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "アウトロー",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 280,
    def: 100,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "アウトローボス",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 360,
    def: 120,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "水兵",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 800,
    def: 800,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "水兵長",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 1000,
    def: 1000,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "造波術師",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 200,
    def: 200,
    res: 60,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "造波術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 260,
    def: 220,
    res: 60,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "造波術師搭乗ボート",
    class: "遠距離",
    atktype: "術",
    hp: 12000,
    atk: 300,
    def: 200,
    res: 0,
    move: 1.1,
    elite: true,
    boss: false,
  },
  {
    name: "造波術師隊長搭乗ボート",
    class: "遠距離",
    atktype: "術",
    hp: 16000,
    atk: 380,
    def: 220,
    res: 0,
    move: 1.1,
    elite: true,
    boss: false,
  },
  {
    name: "水兵搭乗クルーザー",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 1000,
    def: 1000,
    res: 0,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "水兵長搭乗クルーザー",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 1400,
    def: 1200,
    res: 0,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "無人爆弾ボート",
    class: "近距離",
    atktype: "しない",
    hp: 8000,
    atk: 300,
    def: 300,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "無人爆弾ボート改",
    class: "近距離",
    atktype: "しない",
    hp: 10000,
    atk: 400,
    def: 400,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "パンチョの爆弾ボート",
    class: "近距離",
    atktype: "しない",
    hp: 8000,
    atk: 300,
    def: 300,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
  {
    name: "大会輸送艇",
    class: "近距離",
    atktype: "しない",
    hp: 2000,
    atk: 100,
    def: 100,
    res: 0,
    move: 0.65,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン偵察犬",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 300,
    def: 0,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン上級偵察犬",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 380,
    def: 0,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン偵察兵",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 280,
    def: 110,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン偵察隊長",
    class: "近距離",
    atktype: "物理",
    hp: 4400,
    atk: 380,
    def: 180,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン狙撃手",
    class: "遠距離",
    atktype: "物理",
    hp: 3800,
    atk: 250,
    def: 150,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン狙撃隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 380,
    def: 150,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン暗影術師",
    class: "遠距離",
    atktype: "術",
    hp: 4500,
    atk: 300,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン暗影術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 6500,
    atk: 460,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン方陣戦士",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 300,
    def: 300,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン方陣指揮官",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 450,
    def: 400,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン重装兵",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 700,
    def: 750,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン重装隊長",
    class: "近距離",
    atktype: "物理",
    hp: 9000,
    atk: 900,
    def: 1100,
    res: 0,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン飛行兵",
    class: "近・遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 400,
    def: 350,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "ダブリン飛行隊長",
    class: "近・遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 550,
    def: 450,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "墓守の石像",
    class: "近・遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 550,
    def: 550,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "墓守の石像(石像状態)",
    class: "近・遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 550,
    def: 1350,
    res: 30,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "怒れる墓守の石像",
    class: "近・遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 750,
    def: 750,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "怒れる墓守の石像(石像状態)",
    class: "近・遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 750,
    def: 1550,
    res: 30,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン焼滅者",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 500,
    def: 400,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン焼滅隊長",
    class: "遠距離",
    atktype: "術",
    hp: 10000,
    atk: 600,
    def: 550,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリンヘタイロイ衛兵",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 900,
    def: 900,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリンヘタイロイ上級衛兵",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 1100,
    def: 1000,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリンヘタイロイ影刃",
    class: "近距離",
    atktype: "術",
    hp: 12000,
    atk: 400,
    def: 350,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリンヘタイロイ上級影刃",
    class: "近距離",
    atktype: "術",
    hp: 15000,
    atk: 580,
    def: 550,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン喚起術師",
    class: "近距離",
    atktype: "しない",
    hp: 15000,
    atk: 0,
    def: 450,
    res: 40,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "ダブリン喚起術師隊長",
    class: "近距離",
    atktype: "しない",
    hp: 20000,
    atk: 0,
    def: 550,
    res: 50,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "不浄なる鉗獣",
    class: "近距離",
    atktype: "物理",
    hp: 1800,
    atk: 350,
    def: 300,
    res: 30,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "不浄なる鉗獣α",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 400,
    def: 400,
    res: 30,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "無冑盟弩手",
    class: "遠距離",
    atktype: "物理",
    hp: 3000,
    atk: 300,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "無冑盟弩手隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 350,
    def: 150,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "無冑盟刺客",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 400,
    def: 250,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "無冑盟刺客隊長",
    class: "近距離",
    atktype: "物理",
    hp: 5500,
    atk: 500,
    def: 300,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "騎士領の酔漢",
    class: "近距離",
    atktype: "物理",
    hp: 7500,
    atk: 800,
    def: 550,
    res: 20,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "騎士領の凶悪酔漢",
    class: "近距離",
    atktype: "物理",
    hp: 8500,
    atk: 1000,
    def: 550,
    res: 20,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "無冑盟第三小隊",
    class: "遠距離",
    atktype: "物理",
    hp: 6500,
    atk: 500,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "無冑盟第三小隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 600,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "「ラズライト」モニーク",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 600,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "無冑盟スイープ小隊",
    class: "遠距離",
    atktype: "物理",
    hp: 6500,
    atk: 700,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "無冑盟スイープ小隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 800,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "「ラズライト」ロイ",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 800,
    def: 200,
    res: 40,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "ノヴァ見習い騎士",
    class: "遠距離",
    atktype: "術",
    hp: 7500,
    atk: 350,
    def: 300,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ノヴァ精鋭騎士",
    class: "遠距離",
    atktype: "術",
    hp: 8500,
    atk: 450,
    def: 350,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「燭騎士」ヴィヴィアナ",
    class: "遠距離",
    atktype: "術",
    hp: 8500,
    atk: 450,
    def: 350,
    res: 60,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "悪夢のファン",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 1200,
    def: 700,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "悪夢のマニア",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 1500,
    def: 750,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「最後のケシク」トゥーラ",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 1200,
    def: 700,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "「ブラッディブレード」",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 800,
    def: 300,
    res: 80,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "爪獣",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 290,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "凶悪爪獣",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 340,
    def: 0,
    res: 20,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "堅氷",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 300,
    def: 100,
    res: 20,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "堅氷AS.T",
    class: "遠距離",
    atktype: "物理",
    hp: 7000,
    atk: 350,
    def: 150,
    res: 20,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の戦士",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 300,
    def: 100,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の戦士長",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 350,
    def: 150,
    res: 20,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の狩人",
    class: "遠距離",
    atktype: "物理",
    hp: 3500,
    atk: 350,
    def: 100,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の狩人隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 450,
    def: 150,
    res: 20,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の護法者",
    class: "近距離",
    atktype: "術",
    hp: 5000,
    atk: 600,
    def: 250,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "氷原の護法隊長",
    class: "近距離",
    atktype: "術",
    hp: 7000,
    atk: 800,
    def: 350,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "氷原の術師",
    class: "遠距離",
    atktype: "術",
    hp: 5000,
    atk: 250,
    def: 200,
    res: 50,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 320,
    def: 200,
    res: 50,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "氷原の狂戦士",
    class: "近距離",
    atktype: "物理",
    hp: 12000,
    atk: 800,
    def: 800,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "氷原の狂戦士長",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 1000,
    def: 1000,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "チェゲッタ",
    class: "遠距離",
    atktype: "物理",
    hp: 15000,
    atk: 600,
    def: 600,
    res: 50,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "チェゲッタ隊長",
    class: "遠距離",
    atktype: "物理",
    hp: 20000,
    atk: 800,
    def: 700,
    res: 50,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "磨礱",
    class: "近距離",
    atktype: "物理",
    hp: 2000,
    atk: 310,
    def: 0,
    res: 20,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "明鑑",
    class: "近距離",
    atktype: "物理",
    hp: 3100,
    atk: 390,
    def: 0,
    res: 20,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "木製瑞印",
    class: "近距離",
    atktype: "しない",
    hp: 2,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "紅木瑞印",
    class: "近距離",
    atktype: "しない",
    hp: 3,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "俗心",
    class: "近距離",
    atktype: "物理",
    hp: 2500,
    atk: 320,
    def: 60,
    res: 0,
    move: 1.4,
    elite: false,
    boss: false,
  },
  {
    name: "雅気",
    class: "近距離",
    atktype: "物理",
    hp: 3350,
    atk: 410,
    def: 70,
    res: 0,
    move: 1.4,
    elite: false,
    boss: false,
  },
  {
    name: "小説の巻物",
    class: "近距離",
    atktype: "しない",
    hp: 3,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "詩画の巻物",
    class: "近距離",
    atktype: "しない",
    hp: 4,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "身観",
    class: "近距離",
    atktype: "物理",
    hp: 6500,
    atk: 700,
    def: 750,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "言省",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 900,
    def: 900,
    res: 0,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "青銅の鏡",
    class: "近距離",
    atktype: "しない",
    hp: 30,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "黄銅の鏡",
    class: "近距離",
    atktype: "しない",
    hp: 35,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "墨浪",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 400,
    def: 400,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "心涛",
    class: "遠距離",
    atktype: "物理",
    hp: 7600,
    atk: 500,
    def: 500,
    res: 30,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "木製文鎮",
    class: "近距離",
    atktype: "しない",
    hp: 3,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "紅木文鎮",
    class: "近距離",
    atktype: "しない",
    hp: 4,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "煮泉",
    class: "遠距離",
    atktype: "術",
    hp: 6500,
    atk: 280,
    def: 290,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "煎虹",
    class: "遠距離",
    atktype: "術",
    hp: 8750,
    atk: 360,
    def: 380,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "青磁の茶器",
    class: "近距離",
    atktype: "しない物理",
    hp: 4,
    atk: 0,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "彩磁の茶器",
    class: "近距離",
    atktype: "しない物理",
    hp: 6,
    atk: 0,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "青花",
    class: "遠距離",
    atktype: "術",
    hp: 7000,
    atk: 400,
    def: 350,
    res: 50,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "赤霞",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 570,
    def: 450,
    res: 65,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "青磁の花器",
    class: "近距離",
    atktype: "しない",
    hp: 12,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "彩磁の花器",
    class: "近距離",
    atktype: "しない",
    hp: 15,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "沈砂",
    class: "近距離",
    atktype: "物理",
    hp: 11000,
    atk: 1100,
    def: 600,
    res: 30,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "新砥",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 1350,
    def: 750,
    res: 30,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "銅矛",
    class: "近距離",
    atktype: "しない",
    hp: 25,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "鉄矛",
    class: "近距離",
    atktype: "しない",
    hp: 30,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "清明",
    class: "近距離",
    atktype: "術",
    hp: 14000,
    atk: 550,
    def: 850,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "堂皇",
    class: "近距離",
    atktype: "術",
    hp: 18000,
    atk: 700,
    def: 1050,
    res: 20,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "銅の燭台",
    class: "近距離",
    atktype: "しない",
    hp: 35,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "鉄の燭台",
    class: "近距離",
    atktype: "しない",
    hp: 45,
    atk: 0,
    def: 0,
    res: 0,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "求道戦士",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 380,
    def: 150,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "精鋭求道戦士",
    class: "近距離",
    atktype: "物理",
    hp: 4800,
    atk: 400,
    def: 200,
    res: 0,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "求道狙撃手",
    class: "遠距離",
    atktype: "物理",
    hp: 3800,
    atk: 300,
    def: 50,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "精鋭求道狙撃手",
    class: "遠距離",
    atktype: "物理",
    hp: 5500,
    atk: 350,
    def: 100,
    res: 0,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "求道術師",
    class: "遠距離",
    atktype: "術",
    hp: 6000,
    atk: 320,
    def: 200,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "精鋭求道術師",
    class: "遠距離",
    atktype: "術",
    hp: 7500,
    atk: 385,
    def: 250,
    res: 50,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "求道強襲者",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 380,
    def: 200,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "精鋭求道強襲者",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 450,
    def: 250,
    res: 0,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "求道ブレイカー",
    class: "近・遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 800,
    def: 1200,
    res: 0,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "精鋭求道ブレイカー",
    class: "近・遠距離",
    atktype: "物理",
    hp: 18000,
    atk: 1000,
    def: 1500,
    res: 0,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "求道デザートショップ",
    class: "遠距離",
    atktype: "物理",
    hp: 17500,
    atk: 500,
    def: 650,
    res: 30,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "人気求道デザートショップ",
    class: "遠距離",
    atktype: "物理",
    hp: 22500,
    atk: 600,
    def: 650,
    res: 30,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "キャンディカート",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 300,
    def: 100,
    res: 20,
    move: 1.6,
    elite: false,
    boss: false,
  },
  {
    name: "人気キャンディカート",
    class: "近距離",
    atktype: "物理",
    hp: 3800,
    atk: 300,
    def: 200,
    res: 20,
    move: 1.6,
    elite: false,
    boss: false,
  },
  {
    name: "求道レガトゥス",
    class: "近・遠距離",
    atktype: "物理",
    hp: 17000,
    atk: 600,
    def: 500,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "レガトゥス・オレン",
    class: "近・遠距離",
    atktype: "物理",
    hp: 23000,
    atk: 700,
    def: 550,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "大君の触手",
    class: "近距離",
    atktype: "物理",
    hp: 1500,
    atk: 280,
    def: 100,
    res: 10,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "慈悲の触手",
    class: "近距離",
    atktype: "物理",
    hp: 1500,
    atk: 380,
    def: 100,
    res: 10,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "大君の祝福",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 680,
    def: 200,
    res: 20,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "寛大な祝福",
    class: "近距離",
    atktype: "物理",
    hp: 3000,
    atk: 800,
    def: 200,
    res: 20,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ眷属戦士",
    class: "近距離",
    atktype: "物理",
    hp: 3600,
    atk: 340,
    def: 120,
    res: 30,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ眷属戦士隊長",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 400,
    def: 210,
    res: 30,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ眷属工匠",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 300,
    def: 250,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ眷属工匠隊長",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 380,
    def: 350,
    res: 20,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ眷属補給車",
    class: "遠距離",
    atktype: "物理",
    hp: 7000,
    atk: 340,
    def: 550,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ眷属改造補給車",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 420,
    def: 600,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ眷属連鎖術師",
    class: "遠距離",
    atktype: "術",
    hp: 12000,
    atk: 420,
    def: 450,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ眷属連鎖術師隊長",
    class: "遠距離",
    atktype: "術",
    hp: 16000,
    atk: 550,
    def: 550,
    res: 50,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ眷属集恨者",
    class: "近距離",
    atktype: "物理",
    hp: 14000,
    atk: 1000,
    def: 800,
    res: 20,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ眷属集怒者",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 1200,
    def: 800,
    res: 20,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "サルカズ徴用作業ドローン",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 500,
    def: 150,
    res: 10,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ徴用新型ドローン",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 650,
    def: 220,
    res: 10,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "渇血の眷属",
    class: "近距離",
    atktype: "術",
    hp: 4000,
    atk: 90,
    def: 100,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "満腹の眷属",
    class: "近距離",
    atktype: "術",
    hp: 6000,
    atk: 120,
    def: 100,
    res: 0,
    move: 1.7,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ王庭軍戦士",
    class: "近距離",
    atktype: "術",
    hp: 4200,
    atk: 240,
    def: 220,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "サルカズ王庭軍戦士隊長",
    class: "近距離",
    atktype: "術",
    hp: 5500,
    atk: 380,
    def: 280,
    res: 40,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "深溟のファウンダー",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 450,
    def: 200,
    res: 30,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したファウンダー",
    class: "近距離",
    atktype: "物理",
    hp: 9000,
    atk: 600,
    def: 250,
    res: 30,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "退行したファウンダー",
    class: "近距離",
    atktype: "物理",
    hp: 7000,
    atk: 450,
    def: 200,
    res: 30,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "深溟のプレデター",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 450,
    def: 50,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したプレデター",
    class: "近距離",
    atktype: "物理",
    hp: 5000,
    atk: 550,
    def: 80,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "退行したプレデター",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 450,
    def: 50,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "深溟のスプレッダー",
    class: "近距離",
    atktype: "物理",
    hp: 19000,
    atk: 800,
    def: 500,
    res: 5,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したスプレッダー",
    class: "近距離",
    atktype: "物理",
    hp: 24000,
    atk: 900,
    def: 500,
    res: 5,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "退行したスプレッダー",
    class: "近距離",
    atktype: "物理",
    hp: 19000,
    atk: 800,
    def: 500,
    res: 5,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "深溟のスピュワー",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 650,
    def: 100,
    res: 50,
    move: 0.3,
    elite: false,
    boss: false,
  },
  {
    name: "富栄養化したスピュワー",
    class: "遠距離",
    atktype: "物理",
    hp: 5000,
    atk: 800,
    def: 100,
    res: 50,
    move: 0.3,
    elite: false,
    boss: false,
  },
  {
    name: "退行したスピュワー",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 650,
    def: 100,
    res: 50,
    move: 0.3,
    elite: false,
    boss: false,
  },
  {
    name: "深溟のミキサー",
    class: "遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 140,
    def: 550,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したミキサー",
    class: "遠距離",
    atktype: "物理",
    hp: 14000,
    atk: 160,
    def: 550,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "退行したミキサー",
    class: "遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 140,
    def: 550,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "深溟のリーフブレイカー",
    class: "近・遠距離",
    atktype: "物理",
    hp: 20000,
    atk: 300,
    def: 750,
    res: 40,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "富栄養化したリーフブレイカー",
    class: "近・遠距離",
    atktype: "物理",
    hp: 25000,
    atk: 400,
    def: 750,
    res: 40,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "退行したリーフブレイカー",
    class: "近・遠距離",
    atktype: "物理",
    hp: 20000,
    atk: 300,
    def: 750,
    res: 40,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "「街の遊び人」",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 380,
    def: 50,
    res: 0,
    move: 1.3,
    elite: false,
    boss: false,
  },
  {
    name: "「街の酔っ払い」",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 520,
    def: 50,
    res: 0,
    move: 1.3,
    elite: false,
    boss: false,
  },
  {
    name: "「街の芸人」",
    class: "遠距離",
    atktype: "物理",
    hp: 3300,
    atk: 330,
    def: 80,
    res: 10,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "「街の音楽家」",
    class: "遠距離",
    atktype: "物理",
    hp: 4000,
    atk: 360,
    def: 120,
    res: 10,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "量産型巨像",
    class: "近距離",
    atktype: "物理",
    hp: 15000,
    atk: 650,
    def: 1200,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "量産型巨像・改",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 800,
    def: 1400,
    res: 50,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "高塔の術師",
    class: "遠距離",
    atktype: "術",
    hp: 7000,
    atk: 600,
    def: 160,
    res: 65,
    move: 0.6,
    elite: false,
    boss: false,
  },
  {
    name: "ベテラン高塔の術師",
    class: "遠距離",
    atktype: "術",
    hp: 9000,
    atk: 780,
    def: 240,
    res: 65,
    move: 0.6,
    elite: false,
    boss: false,
  },
  {
    name: "残党のバイオリン奏者",
    class: "遠距離",
    atktype: "術",
    hp: 12000,
    atk: 500,
    def: 450,
    res: 40,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "残党のバイオリン首席奏者",
    class: "遠距離",
    atktype: "術",
    hp: 18000,
    atk: 650,
    def: 550,
    res: 40,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "残党のサックス奏者",
    class: "近・遠距離",
    atktype: "物理",
    hp: 17500,
    atk: 800,
    def: 650,
    res: 20,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "残党のサックス首席奏者",
    class: "近・遠距離",
    atktype: "物理",
    hp: 20000,
    atk: 1000,
    def: 700,
    res: 20,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "残党の陣地術師",
    class: "遠距離",
    atktype: "術",
    hp: 15000,
    atk: 0,
    def: 500,
    res: 60,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "残党のベテラン陣地術師",
    class: "遠距離",
    atktype: "術",
    hp: 20000,
    atk: 0,
    def: 650,
    res: 60,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "ドブオリジムシ",
    class: "近距離",
    atktype: "物理",
    hp: 2250,
    atk: 280,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ドブオリジムシα",
    class: "近距離",
    atktype: "物理",
    hp: 3500,
    atk: 370,
    def: 0,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ゲルトルーデ",
    class: "遠距離",
    atktype: "術",
    hp: 20000,
    atk: 700,
    def: 450,
    res: 35,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "ライン生命警備課職員",
    class: "近距離",
    atktype: "物理",
    hp: 4500,
    atk: 410,
    def: 250,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ライン生命警備課上級職員",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 485,
    def: 300,
    res: 0,
    move: 1,
    elite: false,
    boss: false,
  },
  {
    name: "ライン生命エンジニア",
    class: "遠距離",
    atktype: "術",
    hp: 6500,
    atk: 300,
    def: 100,
    res: 50,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "ライン生命上級エンジニア",
    class: "遠距離",
    atktype: "術",
    hp: 8000,
    atk: 375,
    def: 100,
    res: 60,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "Dor-1号失敗作",
    class: "近距離",
    atktype: "物理",
    hp: 2750,
    atk: 310,
    def: 0,
    res: 50,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "Dor-α号失敗作",
    class: "近距離",
    atktype: "物理",
    hp: 3200,
    atk: 360,
    def: 50,
    res: 50,
    move: 1.5,
    elite: false,
    boss: false,
  },
  {
    name: "Dor-2号複製体",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 390,
    def: 0,
    res: 50,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "Dor-β号複製体",
    class: "遠距離",
    atktype: "物理",
    hp: 9000,
    atk: 420,
    def: 50,
    res: 50,
    move: 0.9,
    elite: false,
    boss: false,
  },
  {
    name: "Dor-3号改造体",
    class: "近距離",
    atktype: "術",
    hp: 5000,
    atk: 500,
    def: 1000,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "Dor-γ号改造体",
    class: "近距離",
    atktype: "術",
    hp: 7500,
    atk: 600,
    def: 1200,
    res: 50,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "実験用パワードスーツ",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 700,
    def: 700,
    res: 20,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "テスト用パワードスーツ",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 850,
    def: 800,
    res: 20,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "R-31大型パワードスーツ",
    class: "近距離",
    atktype: "物理",
    hp: 25000,
    atk: 1600,
    def: 1200,
    res: 20,
    move: 0.3,
    elite: false,
    boss: false,
  },
  {
    name: "R-31a大型パワードスーツ",
    class: "近距離",
    atktype: "物理",
    hp: 32500,
    atk: 2000,
    def: 1500,
    res: 20,
    move: 0.3,
    elite: false,
    boss: false,
  },
  {
    name: "R-11突撃型パワードスーツ",
    class: "遠距離",
    atktype: "物理",
    hp: 25000,
    atk: 1200,
    def: 1200,
    res: 20,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "R-11a突撃型パワードスーツ",
    class: "遠距離",
    atktype: "物理",
    hp: 32500,
    atk: 1350,
    def: 1500,
    res: 20,
    move: 0.3,
    elite: true,
    boss: false,
  },
  {
    name: "Dorothy",
    class: "遠距離",
    atktype: "物理",
    hp: 37500,
    atk: 650,
    def: 600,
    res: 0,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "酒類愛好家",
    class: "近距離",
    atktype: "物理",
    hp: 2800,
    atk: 300,
    def: 100,
    res: 50,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "酒類愛好協会員",
    class: "近距離",
    atktype: "物理",
    hp: 3600,
    atk: 400,
    def: 150,
    res: 50,
    move: 1.1,
    elite: false,
    boss: false,
  },
  {
    name: "湖畔のボランティア",
    class: "近距離",
    atktype: "物理",
    hp: 4000,
    atk: 320,
    def: 250,
    res: 50,
    move: 0.95,
    elite: false,
    boss: false,
  },
  {
    name: "湖畔のライフセーバー",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 420,
    def: 250,
    res: 50,
    move: 0.95,
    elite: false,
    boss: false,
  },
  {
    name: "サンドキャッスル建築家",
    class: "遠距離",
    atktype: "術",
    hp: 3500,
    atk: 150,
    def: 300,
    res: 50,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "サンドキャッスルデザイナー",
    class: "遠距離",
    atktype: "術",
    hp: 5000,
    atk: 200,
    def: 300,
    res: 50,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "バレーボールサーブ車",
    class: "遠距離",
    atktype: "物理",
    hp: 6000,
    atk: 350,
    def: 400,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "バレーボールスパイク車",
    class: "遠距離",
    atktype: "物理",
    hp: 8000,
    atk: 450,
    def: 400,
    res: 10,
    move: 0.8,
    elite: false,
    boss: false,
  },
  {
    name: "鋼のインストラクター",
    class: "近距離",
    atktype: "術",
    hp: 8000,
    atk: 400,
    def: 800,
    res: 10,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "合金のインストラクター",
    class: "近距離",
    atktype: "術",
    hp: 12000,
    atk: 500,
    def: 1000,
    res: 10,
    move: 0.75,
    elite: true,
    boss: false,
  },
  {
    name: "防塵サンドバギー",
    class: "近距離",
    atktype: "物理",
    hp: 20000,
    atk: 800,
    def: 1000,
    res: 10,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "レーシングサンドバギー",
    class: "近距離",
    atktype: "物理",
    hp: 30000,
    atk: 1000,
    def: 1000,
    res: 10,
    move: 1.3,
    elite: true,
    boss: false,
  },
  {
    name: "ミード級ソバーロボ",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 1100,
    def: 1500,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "スピリッツ級ソバーロボ",
    class: "近距離",
    atktype: "物理",
    hp: 18000,
    atk: 1500,
    def: 1500,
    res: 10,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "ダック卿",
    class: "近距離",
    atktype: "しない",
    hp: 18000,
    atk: 100,
    def: 200,
    res: 30,
    move: 0.4,
    elite: true,
    boss: false,
  },
  {
    name: "ゴプニク",
    class: "近距離",
    atktype: "物理",
    hp: 30000,
    atk: 2000,
    def: 250,
    res: 50,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "不気味な観客",
    class: "近距離",
    atktype: "物理",
    hp: 8000,
    atk: 750,
    def: 600,
    res: 30,
    move: 1.2,
    elite: true,
    boss: false,
  },
  {
    name: "緋色の歌姫",
    class: "遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 500,
    def: 300,
    res: 60,
    move: 0.8,
    elite: true,
    boss: false,
  },
  {
    name: "運搬用からくり",
    class: "遠距離",
    atktype: "物理",
    hp: 24000,
    atk: 1200,
    def: 300,
    res: 30,
    move: 0.5,
    elite: true,
    boss: false,
  },
  {
    name: "「プチサプライズ」",
    class: "近距離",
    atktype: "しない",
    hp: 4000,
    atk: 400,
    def: 0,
    res: 0,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "不祥の幻影",
    class: "近距離",
    atktype: "物理",
    hp: 10000,
    atk: 750,
    def: 400,
    res: 20,
    move: 0.6,
    elite: true,
    boss: false,
  },
  {
    name: "改造ガス車",
    class: "近・遠距離",
    atktype: "物理",
    hp: 12000,
    atk: 500,
    def: 400,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "拡容改造ガス車",
    class: "近・遠距離",
    atktype: "物理",
    hp: 15000,
    atk: 550,
    def: 500,
    res: 30,
    move: 0.7,
    elite: true,
    boss: false,
  },
  {
    name: "中古低価ドローン",
    class: "近距離",
    atktype: "しない",
    hp: 5000,
    atk: 0,
    def: 100,
    res: 20,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "中古改造ドローン",
    class: "近距離",
    atktype: "しない",
    hp: 10000,
    atk: 0,
    def: 200,
    res: 30,
    move: 0.7,
    elite: false,
    boss: false,
  },
  {
    name: "移動電源",
    class: "近距離",
    atktype: "しない",
    hp: 7500,
    atk: 0,
    def: 250,
    res: 30,
    move: 1.9,
    elite: false,
    boss: false,
  },
  {
    name: "Pompeii",
    class: "遠距離",
    atktype: "術",
    hp: 40000,
    atk: 230,
    def: 200,
    res: 70,
    move: 0.65,
    elite: true,
    boss: true,
  },
  {
    name: "SkullShredder",
    class: "近・遠距離",
    atktype: "物理",
    hp: 10500,
    atk: 1000,
    def: 150,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "CrownSlayer",
    class: "近距離",
    atktype: "物理",
    hp: 6000,
    atk: 400,
    def: 120,
    res: 50,
    move: 1.4,
    elite: true,
    boss: true,
  },
  {
    name: "Talulah",
    class: "近・遠距離",
    atktype: "物理",
    hp: 50000,
    atk: 1500,
    def: 700,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "W",
    class: "遠距離",
    atktype: "物理",
    hp: 10000,
    atk: 470,
    def: 100,
    res: 50,
    move: 1.2,
    elite: true,
    boss: true,
  },
  {
    name: "FrostNova",
    class: "遠距離",
    atktype: "術",
    hp: 25000,
    atk: 420,
    def: 250,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "Mephisto",
    class: "近距離",
    atktype: "しない",
    hp: 28000,
    atk: 500,
    def: 200,
    res: 60,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "Faust",
    class: "遠距離",
    atktype: "物理",
    hp: 37000,
    atk: 1000,
    def: 350,
    res: 35,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「鼠王」",
    class: "遠距離",
    atktype: "術",
    hp: 22000,
    atk: 470,
    def: 350,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "FrostNova・冬痕",
    class: "遠距離",
    atktype: "術",
    hp: 30000,
    atk: 440,
    def: 380,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "Patriot",
    class: "近・遠距離",
    atktype: "物理",
    hp: 45000,
    atk: 1600,
    def: 500,
    res: 45,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "Patriot(進撃態勢)",
    class: "近・遠距離",
    atktype: "物理",
    hp: 45000,
    atk: 2720,
    def: 2100,
    res: 90,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "Patriot(H7-4)",
    class: "近・遠距離",
    atktype: "物理",
    hp: 60000,
    atk: 2000,
    def: 500,
    res: 45,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "Mudrock",
    class: "近距離",
    atktype: "物理",
    hp: 45000,
    atk: 800,
    def: 1000,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "「ビッグアグリー」",
    class: "近・遠距離",
    atktype: "物理",
    hp: 40000,
    atk: 500,
    def: 1000,
    res: 20,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "腐敗騎士",
    class: "近距離",
    atktype: "物理",
    hp: 40000,
    atk: 1200,
    def: 1200,
    res: 30,
    move: 0.65,
    elite: true,
    boss: true,
  },
  {
    name: "凋零騎士",
    class: "遠距離",
    atktype: "術",
    hp: 40000,
    atk: 500,
    def: 600,
    res: 70,
    move: 0.65,
    elite: true,
    boss: true,
  },
  {
    name: "Mephisto・歌う者",
    class: "遠距離",
    atktype: "術",
    hp: 60000,
    atk: 450,
    def: 450,
    res: 30,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "Mephisto・歌う者(休眠状態)",
    class: "遠距離",
    atktype: "術",
    hp: 60000,
    atk: 450,
    def: 2650,
    res: 80,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "「不死の黒蛇」",
    class: "遠距離",
    atktype: "物理",
    hp: 50000,
    atk: 770,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「不死の黒蛇」(狂化状態)",
    class: "遠距離",
    atktype: "物理",
    hp: 75000,
    atk: 1155,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "ジェッセルトン・ウィリアムズ",
    class: "近・遠距離",
    atktype: "物理",
    hp: 25000,
    atk: 700,
    def: 400,
    res: 20,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "ジェッセルトン・ウィリアムズ(殺し屋)",
    class: "近・遠距離",
    atktype: "物理",
    hp: 25000,
    atk: 1400,
    def: 1400,
    res: 20,
    move: 0.9,
    elite: true,
    boss: true,
  },
  {
    name: "「ジザイ」",
    class: "遠距離",
    atktype: "術",
    hp: 30000,
    atk: 500,
    def: 750,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「進化の本質」",
    class: "近距離",
    atktype: "しない",
    hp: 50000,
    atk: 700,
    def: 500,
    res: 50,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "「皇帝の利刃」、追跡者",
    class: "近距離",
    atktype: "物理",
    hp: 28000,
    atk: 600,
    def: 400,
    res: 40,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "「潮風の司教」クイントゥス",
    class: "遠距離",
    atktype: "物理",
    hp: 100000,
    atk: 380,
    def: 500,
    res: 50,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "Mandragora",
    class: "近・遠距離",
    atktype: "術",
    hp: 50000,
    atk: 640,
    def: 520,
    res: 35,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "「血騎士」ディカイオポリス",
    class: "近・遠距離",
    atktype: "物理",
    hp: 30000,
    atk: 1750,
    def: 1000,
    res: 40,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "Degenbrecher",
    class: "近距離",
    atktype: "物理",
    hp: 28000,
    atk: 900,
    def: 600,
    res: 50,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "歳相",
    class: "遠距離",
    atktype: "物理",
    hp: 55000,
    atk: 1400,
    def: 550,
    res: 30,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "歳相(第二形態)",
    class: "遠距離",
    atktype: "物理",
    hp: 75000,
    atk: 1500,
    def: 500,
    res: 30,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "歳相(第三形態)",
    class: "遠距離",
    atktype: "物理",
    hp: 95000,
    atk: 1600,
    def: 500,
    res: 30,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "「殉教者」アンドアイン",
    class: "遠距離",
    atktype: "物理",
    hp: 27000,
    atk: 750,
    def: 550,
    res: 60,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "Manfred",
    class: "遠距離",
    atktype: "術",
    hp: 40000,
    atk: 1000,
    def: 600,
    res: 40,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「ディヴィニティエンド」、大群の意思",
    class: "近・距離",
    atktype: "物理",
    hp: 10000,
    atk: 800,
    def: 700,
    res: 0,
    move: 0.8,
    elite: true,
    boss: true,
  },
  {
    name: "クライデ、「塵界の遺骸」",
    class: "遠距離",
    atktype: "術",
    hp: 60000,
    atk: 800,
    def: 400,
    res: 20,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "「覚醒」",
    class: "近距離",
    atktype: "しない",
    hp: 37500,
    atk: 1200,
    def: 650,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「物欲の拮抗者」",
    class: "遠距離",
    atktype: "術",
    hp: 55000,
    atk: 500,
    def: 600,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "迷子の巨像",
    class: "近・遠距離",
    atktype: "物理",
    hp: 75000,
    atk: 1500,
    def: 600,
    res: 0,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "ジェットマン",
    class: "近距離",
    atktype: "物理",
    hp: 58000,
    atk: 400,
    def: 280,
    res: 0,
    move: 0.8,
    elite: true,
    boss: true,
  },
  {
    name: "「見棄てし者」",
    class: "近・遠距離",
    atktype: "物理",
    hp: 50000,
    atk: 500,
    def: 300,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "錆鎚の戦士",
    class: "遠距離",
    atktype: "物理・術",
    hp: 40000,
    atk: 1200,
    def: 550,
    res: 40,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "「寒災」",
    class: "遠距離",
    atktype: "術",
    hp: 27000,
    atk: 350,
    def: 1500,
    res: 80,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「墓碑」",
    class: "近距離",
    atktype: "物理",
    hp: 60000,
    atk: 2000,
    def: 330,
    res: 55,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "流浪のオートマトン",
    class: "遠距離",
    atktype: "術",
    hp: 40000,
    atk: 900,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「雪の牝鹿」",
    class: "近・距離",
    atktype: "物理",
    hp: 40000,
    atk: 700,
    def: 300,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "「霜の牡鹿」",
    class: "遠距離",
    atktype: "術",
    hp: 60000,
    atk: 1200,
    def: 300,
    res: 30,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "「クリムゾンソリティア」ルシアン",
    class: "近・遠距離",
    atktype: "物理",
    hp: 80000,
    atk: 1500,
    def: 600,
    res: 40,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "傷心の巨錠",
    class: "遠距離",
    atktype: "術",
    hp: 300000,
    atk: 800,
    def: 700,
    res: 60,
    move: 1,
    elite: true,
    boss: true,
  },
  {
    name: "「劇団の喉舌」",
    class: "近・遠距離",
    atktype: "物理",
    hp: 100000,
    atk: 1000,
    def: 0,
    res: 0,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "「劇作家」",
    class: "遠距離",
    atktype: "術",
    hp: 80000,
    atk: 800,
    def: 1000,
    res: 50,
    move: 0.6,
    elite: true,
    boss: true,
  },
  {
    name: "コソ泥フライ",
    class: "近距離",
    atktype: "しない",
    hp: 22000,
    atk: 0,
    def: 700,
    res: 50,
    move: 1,
    elite: true,
    boss: false,
  },
  {
    name: "涙眼の探偵",
    class: "近距離",
    atktype: "物理",
    hp: 19000,
    atk: 400,
    def: 400,
    res: 20,
    move: 0.9,
    elite: true,
    boss: false,
  },
  {
    name: "「キラプル」",
    class: "遠距離",
    atktype: "物理",
    hp: 24000,
    atk: 150,
    def: 700,
    res: 50,
    move: 0.85,
    elite: true,
    boss: false,
  },
  {
    name: "「ミラノ」",
    class: "近距離",
    atktype: "物理",
    hp: 60000,
    atk: 1000,
    def: 800,
    res: 50,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "円岩の巨像",
    class: "近距離",
    atktype: "物理",
    hp: 58000,
    atk: 1800,
    def: 1200,
    res: 50,
    move: 0.4,
    elite: true,
    boss: true,
  },
  {
    name: "粗い円岩",
    class: "近距離",
    atktype: "しない",
    hp: 2000,
    atk: 0,
    def: 1000,
    res: 50,
    move: 0.5,
    elite: false,
    boss: false,
  },
  {
    name: "「ローミングハウス」",
    class: "近距離",
    atktype: "物理",
    hp: 50000,
    atk: 1000,
    def: 1500,
    res: 40,
    move: 0.5,
    elite: true,
    boss: true,
  },
  {
    name: "蛍殻オリジムシ",
    class: "近距離",
    atktype: "物理",
    hp: 3200,
    atk: 260,
    def: 1200,
    res: 0,
    move: 1.2,
    elite: false,
    boss: false,
  },
];
